import { render, staticRenderFns } from "./layout-distribute.vue?vue&type=template&id=236b6463&scoped=true&"
import script from "./layout-distribute.vue?vue&type=script&lang=js&"
export * from "./layout-distribute.vue?vue&type=script&lang=js&"
import style0 from "./layout-distribute.vue?vue&type=style&index=0&id=236b6463&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b6463",
  null
  
)

export default component.exports